import { FC } from 'react'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

interface Props {
  icon: AllIcons
  title: string
  description: string
}

export const BlockInfo: FC<Props> = ({ icon, title, description }) => {
  return (
    <Paper padding={[16]}>
      <div className={s.container}>
        <div className={s.left}>
          <AppIcon
            id={icon}
            className={s.icon}
            height={24}
            width={24}
          />
        </div>

        <div className={s.right}>
          <p className={s.title}>{title}</p>
          <span className={s.description}>{description}</span>
        </div>
      </div>
    </Paper>
  )
}
